import { render, staticRenderFns } from "./website-info-tab.vue?vue&type=template&id=317a9832&scoped=true"
import script from "./website-info-tab.vue?vue&type=script&lang=js"
export * from "./website-info-tab.vue?vue&type=script&lang=js"
import style0 from "./website-info-tab.vue?vue&type=style&index=0&id=317a9832&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a9832",
  null
  
)

export default component.exports